import { render, staticRenderFns } from "./TagUser.vue?vue&type=template&id=38d6772e&"
import script from "./TagUser.vue?vue&type=script&lang=js&"
export * from "./TagUser.vue?vue&type=script&lang=js&"
import style0 from "./TagUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports